import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import Scrollable from '@sorare/core/src/atoms/navigation/Scrollable';
import { LabelM } from '@sorare/core/src/atoms/typography';

const Root = styled(Vertical)`
  position: relative;
  padding: 0 var(--double-unit);
`;

const Img = styled.img`
  user-select: none;
  filter: drop-shadow(
    0px 0px var(--triple-unit) rgba(var(--c-rgb-rivals-purple), 0.6)
  );
`;

const ItemWrapper = styled(Vertical)`
  padding: var(--quadruple-unit) 0;
`;

export type Avatar = {
  __typename: string;
  id: string;
  pictureUrl: string;
  name: string;
};

type Props = {
  avatars: Avatar[];
  onChange?: (item: Avatar) => void;
  onLoadMore?: () => void;
};
export const AvatarSelector = ({ avatars, onChange, onLoadMore }: Props) => {
  if (!avatars.length) {
    return null;
  }

  const totalCount = avatars.length;
  const lastIndex = totalCount - 1;

  const onVisibleItemsChanged = (items: number[]) => {
    const currentlySelectedIndex = items[0];
    if (currentlySelectedIndex === lastIndex) {
      onLoadMore?.();
    }
    const currentlySelectedAvatar = avatars[currentlySelectedIndex];
    if (currentlySelectedAvatar) {
      onChange?.(currentlySelectedAvatar);
    }
  };

  return (
    <Root>
      <Scrollable
        itemToDisplay={1}
        onVisibleItemsChanged={onVisibleItemsChanged}
        scrollButtonsProps={{
          displayOnlyOnHover: false,
          behavior: 'instant',
        }}
      >
        {avatars.map(({ pictureUrl, name }) => (
          <ItemWrapper key={pictureUrl} center>
            <Img src={pictureUrl} height={80} alt="" />
            <LabelM bold>{name}</LabelM>
          </ItemWrapper>
        ))}
      </Scrollable>
    </Root>
  );
};
